import * as React from "react"
import Loading from "@modules/ui/components/Loading"
import {
  provisionLogs as logsText,
  deployNow as text,
} from "@modules/locales/default"
import { useSiteProvisionLogs } from "../hooks/useSiteProvisionLogs"
import { EmptyState, RawLogs } from "gatsby-interface"
import { EmptyStateGraphic } from "@modules/ui/components/EmptyStateGraphic"
import { ErrorAlert } from "@modules/ui/components/ErrorAlert"
import { SiteProvisionStatus } from "@modules/graphql/types"

const statusMessages = {
  [SiteProvisionStatus.InProgress]: text.messages.provisioningInProgress,
  [SiteProvisionStatus.CloningRepo]: text.messages.cloningRepo,
  [SiteProvisionStatus.InstallingDependencies]:
    text.messages.installingDependencies,
  [SiteProvisionStatus.RunningScript]: text.messages.runningScript,
  [SiteProvisionStatus.Failed]: text.messages.provisioningFailed,
  [SiteProvisionStatus.Success]: text.messages.success,
}

export type SiteProvisionJobLogsListProps = {
  jobId: string
  siteId: string
  currentProvisionStatus: SiteProvisionStatus
}

export function ProvisioningRawLogs({
  jobId,
  siteId,
  currentProvisionStatus,
}: SiteProvisionJobLogsListProps) {
  const [logs, { loading, error }] = useSiteProvisionLogs(jobId, siteId)

  if (error) {
    return <ErrorAlert>{error.message}</ErrorAlert>
  }

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "50vh",
      }}
    >
      {loading || currentProvisionStatus === SiteProvisionStatus.InProgress ? (
        <Loading
          variant="baby"
          message={statusMessages[currentProvisionStatus]}
        />
      ) : logs.length === 0 ? (
        <EmptyState
          graphic={<EmptyStateGraphic />}
          heading={logsText.headers.noRawLogs}
          text=""
          variant="WITH_BACKGROUND"
        />
      ) : (
        <RawLogs
          css={{ height: "100%", width: "100%" }}
          logItems={logs}
          aria-label="Raw logs"
        />
      )}
    </div>
  )
}
